// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19Xyv","top":"styles_top__130Tr"};